<template>
  <!-- BEGIN: Content-->
  <div class="app-content content ">
    <div class="content-overlay"></div>
    <div class="header-navbar-shadow"></div>
    <div class="content-wrapper">
      <div class="content-header row">
        <div class="content-header-left col-md-9 col-12 mb-2">
          <Breadcrumb
            name="Add Charges"
            bc1="App"
            bc2="Add Charges"
            bc3="Add"
            path="schemas"
          ></Breadcrumb>
        </div>
        <div class="col-3">
          <div class="d-flex align-items-center justify-content-end">
            <button
                type="button"
                class="btn btn-gradient-danger btn-sm"
                @click="$router.back()"
            >
              <span class="text-nowrap">Back</span>
            </button>
          </div>
        </div>
      </div>
      <div class="content-body">
        <!-- Basic Horizontal form layout section start -->
        <section id="basic-horizontal-layouts">
          <div class="row">
            <div class="col-md-12 col-12">
              <div class="card">
                <div class="card-header">
                  <h4 class="card-title">Add Details</h4>
                </div>
                <div class="card-body">
                  <form class="form form-horizontal">
                    <div class="row">
                      <div class="col-12">
                        <div class="form-group row">
                          <div class="col-sm-12">
                            <label class="mb-1">Select Charges</label>
                            <div class="input-group">
                              <select v-validate="'required'" :class=" errorBag.has('selectedCharge') ? 'is-invalid' : ''" name="selectedCharge" class="custom-select custom-select-sm" v-model="selectedCharge">
                                <option :value="null">Select Charge</option>
                                <option   :value="item" v-for="(item,index) in chargesData" :key="index">{{ item.name }}</option>
                              </select>
                              <small
                                  v-show="errorBag.has('selectedCharge')"
                                  class="invalid-feedback"
                              >{{ "*" + errorBag.first("selectedCharge") }}</small>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div  v-if="selectedCharge && selectedCharge.type.toUpperCase() == 'CARD'" class="col-12">
                        <div class="form-group row">
                          <div class="col-sm-3 col-form-label">
                            <label></label>
                          </div>
                          <div class="col-sm-9">
                            <div class="table">
                              <table >
                                <thead>
                                <tr>
                                  <th>Name</th>
                                  <th>Type</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr :key="index" v-for="(i, index) in chargesDetails">
                                  <td>{{ i.card_meta_data_name }}</td>
                                  <td>{{ i.card_meta_data_type_name }}</td>
                                </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-12">
                        <div class="form-group row">
                          <div class="col-sm-12">
                            <label class="mb-1">Charge Applied At</label>
                            <div class="input-group">
                              <select v-validate="'required'" :class=" errorBag.has('chargeAppliedAt') ? 'is-invalid' : ''" name="chargeAppliedAt" class="custom-select custom-select-sm" v-model="chargeAppliedAt">
                                <option :value="null" >Select</option>
                                <option value="total" >Total</option>
                                <option value="limit" >Limit</option>
                              </select>
                              <small
                                  v-show="errorBag.has('chargeAppliedAt')"
                                  class="invalid-feedback"
                              >{{ "*" + errorBag.first("chargeAppliedAt") }}</small>
                            </div>

                          </div>
                        </div>
                      </div>
                      <div v-if="chargeAppliedAt && chargeAppliedAt == 'total'" class="col-12">
                        <div class="form-group row">
                          <div class="col-sm-12">
                            <div class="row">
                              <div class="col-3">
                                <label class="font-small-1">Charges</label>
                                <input class="form-control form-control-sm" type="number" min="0" value="0" step="any" v-model="totalFieldsData[0]['charges']" placeholder="Charges" />
                              </div>
                              <div class="col-3">
                                <label class="font-small-1">Charge Type</label>
                                <select class="form-control form-control-sm" v-model="totalFieldsData[0]['type']">
                                  <option value="" selected>Select</option>
                                  <option value="fixed" >fixed</option>
                                  <option value="percent" >percent</option>
                                </select>
                              </div>
                              <div class="col-3">
                                <label class="font-small-1">GW Charges</label>
                                <input class="form-control form-control-sm" type="number" min="0" value="0" step="any" v-model="totalFieldsData[0]['gwcharges']" placeholder="GW Charges" />
                              </div>
                              <div class="col-3">
                                <label class="font-small-1">GW Charge Type</label>
                                <select class="form-control form-control-sm" v-model="totalFieldsData[0]['gwType']">
                                  <option value="" selected>Select</option>
                                  <option value="fixed" >fixed</option>
                                  <option value="percent" >percent</option>
                                </select>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div v-if="chargeAppliedAt && chargeAppliedAt == 'limit'" class="col-12">
                        <div class="form-group row">
                          <div class="col-sm-12">
                            <div>
                              <div class="row mt-1 no-gutters">
                                <div class="col-2 custom-col"><label class="font-small-1">Amount</label></div>
                                <div class="col-2 custom-col"><label class="font-small-1">Condition</label></div>
                                <div class="col-2 custom-col"><label class="font-small-1">Charges</label></div>
                                <div class="col-1 custom-col"><label class="font-small-1">Charges Type</label></div>
                                <div class="col-2 custom-col"><label class="font-small-1">GW Charges</label></div>
                                <div class="col-2 custom-col"><label class="font-small-1">GW Charges Type</label></div>
                              </div>
                              <div class="row mt-1 no-gutters" v-for="(limitField,limitFieldIndex) in limitFieldsData" :key="limitFieldIndex">
                                <div class="col-2 custom-col">
                                    <input class="form-control form-control-sm" placeholder="Amount" type="number" min="0" value="0" step="any"  v-model="limitFieldsData[limitFieldIndex]['amount']" />
                                </div>
                                <div class="col-2 pr-0 custom-col">
                                    <select style="font-size: smaller" class="form-control form-control-sm" v-model="limitFieldsData[limitFieldIndex]['condition']">
                                      <option value="" selected>Condition</option>
                                      <option value="=">= (Equals To)</option>
                                      <option value="&gt;">&gt; (Greater Than)</option>
                                      <option value="&gt;=">&gt;= (Greater Than Equals To)</option>
                                      <option value="&lt;">&lt; (Lesser Than)</option>
                                      <option value="&lt;=">&lt;= (Lesser Than Equals To)</option>
                                      <option value="!=">!= (Not Equals To)</option>
                                    </select>
                                </div>
                                <div class="col-2 custom-col">
                                  <input class="form-control form-control-sm" type="number" min="0" value="0" step="any" placeholder="Charges" v-model="limitFieldsData[limitFieldIndex]['charges']" />
                                </div>
                                <div class="col-1 custom-col">
                                  <select class="form-control form-control-sm" v-model="limitFieldsData[limitFieldIndex]['type']">
                                    <option value="" selected>Type</option>
                                    <option value="fixed" >fixed</option>
                                    <option value="percent" >percent</option>
                                  </select>
                                </div>
                                <div class="col-2 custom-col">
                                  <input class="form-control form-control-sm"  type="number" min="0" value="0" step="any" placeholder="GW Charges" v-model="limitFieldsData[limitFieldIndex]['gwcharges']" />
                                </div>
                                <div class="col-1 custom-col">
                                  <select class="form-control form-control-sm" v-model="limitFieldsData[limitFieldIndex]['gwType']">
                                    <option value="" selected>Type</option>
                                    <option value="fixed" >fixed</option>
                                    <option value="percent" >percent</option>
                                  </select>
                                </div>
                                <div class="col-sm-1 col-form-label ml-1" @click="removeField(limitFieldIndex)">
                                  <i class="fa fa-trash" style="cursor: pointer" ></i>
                                </div>
                              </div>
                              <div class="row">
                                <div class="col-sm-12">
                                  <button type="button" class="btn btn-success btn-warning btn-sm mt-1" @click="addMoreFields">Add More</button>
                                </div>
                              </div>
                            </div>

                          </div>
                        </div>
                      </div>

                      <div class="col-sm-9 offset-sm-3 d-flex justify-content-end mt-1">
                        <button
                          type="button"
                          class="btn btn-primary mr-1 d-flex"
                          @click="sendCall"
                          :disabled="loading"
                        >
                          <Loader :loading="loading" :size="size"></Loader>
                          Submit
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>

            </div>
          </div>
        </section>
        <ConfirmationModal :show="showConfirmationModal" @confirm="confirm" message="Are you sure you want to remove this?"
                           title="Remove Item"
                           @hide="showConfirmationModal = false"></ConfirmationModal>

      </div>
    </div>
  </div>
  <!-- END: Content-->
</template>

<script>

export default {

  mounted() {
    this.getChargesData()
    var schemaAcquiringTransactionTypesCharges = this.$store.getters.getByKey(
        "schemaAcquiringTransactionTypesCharges"
    );
    this.schemaAquiringId = parseInt(atob(this.$route.params.acquiringId))
    this.aquiringTransactionTypeId = schemaAcquiringTransactionTypesCharges.row.pivot.id
  },
  data() {
    return {
      totalFieldsData:[
        {
          "charges": '',
          "gwcharges": '',
          "type": "",
          "gwType": ""
        }
      ],
      selectedIndex:null,
      showConfirmationModal: false,
      selectedCharge:null,
      chargeAppliedAt:null,
      charges:'',
      schemaAquiringId:'',
      aquiringTransactionTypeId:'',
      type:'fixed',
      loading: false,
      size: "10px",
      chargesData:[],
      gwCharges:'',
      chargesDetails:[],
      limitFieldsData:[]

    };
  },
  methods: {
    addMoreFields(){
      this.limitFieldsData.push({
        "amount": '',
        "charges": '',
        "gwcharges": '',
        "condition": '=',
        "type": "",
        "gwType": ""
      })
    },
    removeField(index) {
      this.selectedIndex = index
      this.showConfirmationModal = true

    },
    confirm(){
      this.limitFieldsData.splice(this.selectedIndex, 1);
      this.showConfirmationModal = false
    },
    sendCall(){
      this.$validator.validateAll().then(valid => {
        if (valid) {
          let limitFields = []
          if(this.limitFieldsData.length > 0){
             limitFields = this.limitFieldsData.map(item => {
              return {
                ...item,
                amount: parseFloat(item.amount) * 100
              };
            });
          }
          this.loading = true
          let data = {
            schemaAquiringId: this.schemaAquiringId,
            aquiringTransactionTypeId: this.aquiringTransactionTypeId,
            chargeId: this.selectedCharge.id,
            charges: this.chargeAppliedAt == 'limit' ? JSON.stringify(limitFields) : JSON.stringify(this.totalFieldsData),
            applyChargesInLimits : this.chargeAppliedAt == 'limit' ? 1 : 0,
            replicateCharges:0
          }
          this.makeRequest("post", "v1/add-schema-aquiring-charges", data).then(
            callResponse => {
              this.loading = false
              if (!callResponse.error) {
                let code = callResponse.response.data.code;
                if (code == 200) {
                  this.$router.back()
                }
              }
            }
          );
        }
      })

     
    },
    getChargesDetails(chargeId){
      this.makeRequest("post", "v1/get-charges", {chargeId: chargeId}, {}, false,true,[205]).then(
          callResponse => {
            if (!callResponse.error) {
              let code = callResponse.response.data.code;
              if (code == 200) {
                let data = []
                data = callResponse.response.data.data;
                if(data){
                  this.chargesDetails = data
                }

              }
            }
          }
      );
    },
    getChargesData() {
      this.makeRequest("post", "v1/get-charges", { status: 1 },{},false,true,[205]).then(
          callResponse => {
            if (!callResponse.error) {
              let code = callResponse.response.data.code;
              if (code == 200) {
                let data = []
                data = callResponse.response.data.data;
                if(data){
                  this.chargesData = data
                }

              }
            }
          }
      );
    },


  },
  watch:{
    type(val){
     this.charges=''
     this.gwCharges = ''
    },
    selectedCharge(val){
      if(val && val.type.toUpperCase() == 'CARD'){
        this.getChargesDetails(val.id)
      }
    },
    chargeAppliedAt(val){
      this.limitFieldsData = []
      this.totalFieldsData = [
        {
          "charges": '',
          "gwcharges": '',
          "type": "",
          "gwType": ""
        }
      ]
      if(val == 'limit'){
        this.addMoreFields()
      }
    }
  }

};
</script>

